import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaArrowUp } from 'react-icons/fa';
import logoImage from '../data/images/logo_w.png';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const oneWayRoutesColumn1 = [
    'One Way Taxi Chennai to Bangalore',
    'One Way Taxi Chennai to Pondicherry',
    'One Way Taxi Chennai to Madurai',
    'One Way Taxi Chennai to Trichy',
    'One Way Taxi Chennai to Coimbatore',
    'One Way Taxi Chennai to Cuddalore',
    'One Way Taxi Chennai to Kanyakumari',
    'One Way Taxi Chennai to Kumbakonam',
    'One Way Taxi Chennai to Thanjavur'
  ];

  const oneWayRoutesColumn2 = [
    'One Way Taxi Kodaikanal to Madurai',
    'One Way Taxi Palani to Kodaikanal',
    'One Way Taxi Madurai to Rameshwaram',
    'One Way Taxi Thiruvannamalai to Chennai',
    'One Way Taxi Madurai to Trichy',
    'One Way Taxi Bangalore to Chennai',
    'One Way Taxi Coimbatore to Kodaikanal',
    'One Way Taxi Coimbatore to Salem',
    'One Way Taxi Chennai to Vellore'
  ];

  const oneWayRoutesColumn3 = [
    'One Way Taxi Cuddalore to Chennai',
    'One Way Taxi Dindigul to Kodaikanal',
    'One Way Taxi Karur to Coimbatore',
    'One Way Taxi Kodaikanal to Coimbatore',
    'One Way Taxi Madurai to Kodaikanal',
    'One Way Taxi Pondicherry to Chennai',
    'One Way Taxi Rameshwaram to Madurai',
    'One Way Taxi Salem to Bangalore',
    'One Way Taxi Villupuram to Pondicherry'
  ];

  const popularCities = [
    'Chennai', 'Bangalore', 'Pondicherry', 'Madurai', 
    'Coimbatore', 'Trichy', 'Vellore'
  ];

  const services = [
    'Airport Taxi', 'Outstation Taxi', 'One Way Cab'
  ];

  const airportServices = [
    'Chennai Airport Taxi Service',
    'Bangalore Airport Taxi Service',
    'Coimbatore Airport Taxi Service',
    'Trichy Airport Taxi Service',
    'Madurai Airport Taxi Service'
  ];

  return (
    <footer className="footer">
      {/* Support Banner */}
      <div className="support-banner">
        <div className="support-content">
          <span>Need Help? Contact Our Support Team +91 7200085345</span>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="footer-container">
          {/* Left Column - Company Info */}
          <div className="footer-column company-info">
            <div className="company-logo">
              <img src={logoImage} alt="Drop Taxi Services" className="footer-logo-image" />
              <h3 className="company-name">DROPTAXISERVICES.in</h3>
            </div>
            
            <div className="address">
              <FaMapMarkerAlt className="address-icon" />
              <div className="address-text">
                <div>5/59 Mettu Street ,</div>
                <div>MOULIVAKKAM</div>
                <div>CHENNAI - 600125</div>
              </div>
            </div>

            <div className="contact-details">
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <span>+91 7200085345</span>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <span>support@droptaxiservices.in</span>
              </div>
            </div>

            <div className="airport-services">
              <h4 className="section-title">Airport Outstation Taxi</h4>
              <ul className="service-list">
                {airportServices.map((service, index) => (
                  <li key={index}>{service}</li>
                ))}
              </ul>
            </div>
          </div>

          {/* Top Section - Popular Cities & Services */}
          <div className="footer-top-section">
            <div className="popular-cities">
              <h4 className="section-title green">Popular Cities:</h4>
              <div className="cities-list">
                {popularCities.map((city, index) => (
                  <span key={index} className="city-item">
                    {city}
                    {index < popularCities.length - 1 && <span className="separator"> | </span>}
                  </span>
                ))}
              </div>
            </div>

            <div className="services-section">
              <h4 className="section-title green">Services:</h4>
              <div className="services-list">
                {services.map((service, index) => (
                  <span key={index} className="service-item">
                    {service}
                    {index < services.length - 1 && <span className="separator"> | </span>}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Three Column Routes Section */}
          <div className="routes-columns">
            <div className="routes-column">
              <h4 className="section-title">One Way Outstation Trip</h4>
              <ul className="routes-list">
                {oneWayRoutesColumn1.map((route, index) => (
                  <li key={index}>{route}</li>
                ))}
              </ul>
            </div>
            
            <div className="routes-column">
              <h4 className="section-title">One Way Outstation Trip</h4>
              <ul className="routes-list">
                {oneWayRoutesColumn2.map((route, index) => (
                  <li key={index}>{route}</li>
                ))}
              </ul>
            </div>
            
            <div className="routes-column">
              <h4 className="section-title">One Way Outstation Trip</h4>
              <ul className="routes-list">
                {oneWayRoutesColumn3.map((route, index) => (
                  <li key={index}>{route}</li>
                ))}
              </ul>
            </div>
          </div>

        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-copyright">
        <div className="copyright-container">
          <p className="copyright-text">
            copyright © 2025 <span className="company-highlight">DROP TAXI SERVICES</span> All Rights Reserved.
          </p>
        </div>
      </div>

    </footer>
  );
};

export default Footer;